var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"favorite-page"},[_vm._v(" 收藏夹 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }